import React, { Component } from 'react';

import SectionList from './Section/SectionList';

class SectionTeam extends Component {

  render() {

    const { $$data, barOffset, width } = this.props;

    const align = 'left';

    const barColor = '#e24b4b';

    const listProps = {id: 'equipe', data: $$data, barOffset, align, className: 'SectionTeam', title: 'L\'Equipe', titleIcon: 'team', titleColor: '#6b6b6b', sectionBg: true, titleSize: width};
    return (
      <SectionList barColor={barColor} style={this.props.style || {}} {...listProps}  />
    );
  }
}

export default SectionTeam;



// WEBPACK FOOTER //
// ./src/components/Home/SectionTeam.jsx